<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let highlights: string[] = [];
  export let dataTestIdSuffix: string = "";
  const testIdSuffix = dataTestIdSuffix ? `-${dataTestIdSuffix}` : "";
  const dataTestId = `content-block-highlights${testIdSuffix}`;

  const highlightMissing = highlight => {
    return (highlight || "X").split("").every(h => h === "X" || h === " ");
  };

</script>

{#if highlights.length}
  <div data-testid={dataTestId}>
    <div class="fizz-stack-16" />
    <div class="fizz-surface-gray">
      <div class="fizz-inset-square-12 fizz-flow-8">
        {#each highlights as highlight}
          <div class="fizz-flex-row" data-testid="content-block-highlight">
            <Icon type="HighlightArrow" extraClassNames="fizz-inline-8" />
            <div>
              <span
                class:content-block-highlight-missing={highlightMissing(highlight)}
                data-testid={`content-block-highlight${
                  highlightMissing(highlight) ? "-missing" : "-present"
                }`}
              >
                {highlight}
              </span>
            </div>
          </div>
        {/each}
      </div>
    </div>
  </div>
{/if}
